import { Page } from '@/core/architecture'

import { RecentViewedItemsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * RecentViewedItems Page
 * Implemented as a practical sample.
 */
export const RecentViewedItems: Page = () => {
  const { state, actions } = useViewModel()

  return <RecentViewedItemsTemplate state={state} {...actions} />
}
